import GroupModal from './GroupModal';

export default GroupModal;
